import Header from "../../../shared/common/Header";
import PlayersTable from "../components/players/PlayersTable";
import { useTheme } from '../../../shared/common/ThemeContext';

const PlayersListPage = ({ setPlayers, players }) => {
    const { isDarkMode } = useTheme();

    return (
        <div className={`flex-1 overflow-auto relative z-10 ${isDarkMode ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-800"}`}>
            <main className={`mx-auto py-6 px-4 lg:px-8`}>
                <PlayersTable setPlayers={setPlayers} players={players} />
            </main>
        </div>
    );
};

export default PlayersListPage;
